import { supabase } from '@/lib/supabase/client';
import type { Surah } from '@/types/domain';

/**
 * List all 114 surahs ordered by id (1..114).
 *
 * Reads: quran_core.surahs (read-only).
 *
 * We use `.select('*')` and cast the result. supabase-js's column-string
 * inference can resolve to `GenericStringError` when the Database type
 * comes from a hand-written types.gen.ts; `*` is unambiguous and the
 * cast is sound because the runtime returns every column on the row.
 */
export async function listSurahs(): Promise<Surah[]> {
  const { data, error } = await supabase
    .schema('quran_core')
    .from('surahs')
    .select('*')
    .order('id', { ascending: true });

  if (error) throw error;
  return (data ?? []) as Surah[];
}

/**
 * Get a single surah by its id (1..114).
 */
export async function getSurah(id: number): Promise<Surah | null> {
  const { data, error } = await supabase
    .schema('quran_core')
    .from('surahs')
    .select('*')
    .eq('id', id)
    .maybeSingle();

  if (error) throw error;
  return (data as Surah | null) ?? null;
}
